package pl.decks.personal.components.widgets.splitcard

import com.varabyte.kobweb.compose.css.ColorInterpolationMethod
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.colorMix
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import pl.decks.personal.styles.SiteLayout

object SplitCardStylesheet {
    object Vars {
        val indentLineWidth by StyleVariable(SiteLayout.Line.Thick)
        val separatorLineWidth by StyleVariable(SiteLayout.Line.Hairline)

        val cardAccentColor by StyleVariable<Color>()

        val primaryTransitionDuration by StyleVariable(TransitionDurationVars.Fast.value())
        val secondaryTransitionDuration by StyleVariable(TransitionDurationVars.VerySlow.value())

        object Internal {
            val dividerColor by StyleVariable<Color>()
        }
    }

    val Card = CssStyle {
        val accent = Vars.cardAccentColor.value(colorMode.toPalette().color)
        val shadow = colorMix(
            interpolation = ColorInterpolationMethod.Hsl,
            color1 = accent to 30.percent,
            color2 = Colors.Transparent to 70.percent,
        )
        base {
            Modifier
                .borderRadius(SiteLayout.Rounding.XLarge)
                .borderLeft(Vars.indentLineWidth.value(), LineStyle.Solid, Colors.Transparent)
                .overflow(Overflow.Hidden)
                .transition {
                    property("border-left", "box-shadow")
                    timingFunction(TransitionTimingFunction.EaseInOut)
                    duration(Vars.primaryTransitionDuration.value(), Vars.secondaryTransitionDuration.value())
                }
        }
        hover {
            Modifier
                .borderLeft(Vars.indentLineWidth.value(), LineStyle.Solid, accent)
                .boxShadow(
                    offsetX = SiteLayout.Offset.XLarge,
                    offsetY = SiteLayout.Offset.XLarge,
                    blurRadius = SiteLayout.Offset.XXXLarge,
                    color = shadow,
                )
                .setVariable(Vars.Internal.dividerColor, accent)
        }
        active {
            Modifier
                .borderLeft(Vars.indentLineWidth.value(), LineStyle.Solid, accent)
                .boxShadow(
                    offsetX = SiteLayout.Offset.XLarge,
                    offsetY = SiteLayout.Offset.XLarge,
                    blurRadius = SiteLayout.Offset.XXXLarge,
                    color = shadow,
                )
                .setVariable(Vars.Internal.dividerColor, accent)
        }
    }

    val Divider = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .margin(SiteLayout.Space.none)
            .borderTop(Vars.separatorLineWidth.value(), LineStyle.Solid, Vars.Internal.dividerColor.value(colorMode.toPalette().border))
            .transition {
                property("border-top")
                timingFunction(TransitionTimingFunction.EaseInOut)
                duration(Vars.secondaryTransitionDuration.value())
            }
    }
}
